import { Grid, Typography } from "@mui/material";
import { NavbarItem } from "./NavbarItem";
import { useState } from "react";
import styles from "../css/GadgetBuilderGuide.module.css";
import { StepInfo } from "./StepInfo";
import LoginToGB from "../../../images/LoginToGB.png";
import RegisterGadget from "../../../images/RegisterGadget.png";
import UploadRootPackage from "../../../images/UploadRootPackage.png";
import GadgetDetails from "../../../images/GadgetDetails.png";
import IOFormats from "../../../images/IOFormats.png";
import IconSnapshots from "../../../images/IconSnapshots.png";
import SubmitForReview from "../../../images/SubmitForReview.png";
import { CustomModal } from "../../../components/Modal/CustomModal";
import manifest from "../../../docs/manifest.json";
import { JsonViewer } from "../../../components/JsonViewer";

export const GadgetBuilderGuide = () => {
    const [selectedIndex, setSelectedIndex] = useState<number>(1);
    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    return (
        <div className={styles.guideContainer} data-testid="gadget-builder-guide">
            <CustomModal
                open={openModal} 
                handleClose={handleCloseModal}
                children={<JsonViewer data={manifest}/>}
            />
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <div className={styles.navbar}>
                        <NavbarItem index={1} headerText="Login" infoText="Login to Agent Builder 2X" selected={selectedIndex === 1} setSelectedIndex={setSelectedIndex} dataTestId="login-guide"/>
                        <NavbarItem index={2} headerText="Agent" infoText="Register a Agent" selected={selectedIndex === 2} setSelectedIndex={setSelectedIndex} dataTestId="register-gadget-guide"/>
                        <NavbarItem index={3} headerText="Root Package" infoText="Upload a ZIP file containing agent files" selected={selectedIndex === 3} setSelectedIndex={setSelectedIndex} dataTestId="root-package-guide"/>
                        <NavbarItem index={4} headerText="Agent Details" infoText="Check the Agent Details" selected={selectedIndex === 4} setSelectedIndex={setSelectedIndex} dataTestId="gadget-details-guide"/>
                        <NavbarItem index={5} headerText="I/O Formats" infoText="Check the I/O formats" selected={selectedIndex === 5} setSelectedIndex={setSelectedIndex} dataTestId="io-formats-guide"/>
                        <NavbarItem index={6} headerText="Icons and Snapshots" infoText="Check the icons and snapshots" selected={selectedIndex === 6} setSelectedIndex={setSelectedIndex} dataTestId="icon-snapshot-guide"/>
                        <NavbarItem index={7} headerText="Submit the Agent" infoText="Submit for approval" selected={selectedIndex === 7} setSelectedIndex={setSelectedIndex} dataTestId="submit-gadget-guide"/>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <StepInfo
                        headerText="Login to Agent Builder"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="login-info-text">Use valid credentials to the Agent Builder 2X</Typography>}
                        screenshot={LoginToGB}
                        active={selectedIndex === 1}
                        containerDataTestId="login-guide-container"
                        headerTextDataTestId="login-header-text"
                        screenshotDataTestId="login-info-screenshot"
                    />
                    <StepInfo
                        headerText="Register a new Agent"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="register-gadget-info-text">Click on New Agent to Register a new Agent</Typography>}
                        screenshot={RegisterGadget}
                        active={selectedIndex === 2}
                        containerDataTestId="register-gadget-guide-container"
                        headerTextDataTestId="register-gadget-header-text"
                        screenshotDataTestId="register-gadget-screenshot"
                    />
                    <StepInfo
                        headerText="Upload a Root Package"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="root-package-info-text">Click on Upload new Package to upload a ZIP containing <span onClick={handleOpenModal} >manifest.json</span> along with other required files</Typography>}
                        screenshot={UploadRootPackage}
                        active={selectedIndex === 3}
                        containerDataTestId="root-package-guide-container"
                        headerTextDataTestId="root-package-header-text"
                        screenshotDataTestId="root-package-screenshot"
                    />
                    <StepInfo
                        headerText="Verify Agent Details"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="gadget-details-info-text">Check if the Agent Details are mapped from manifest.json after uploading the root ZIP</Typography>}
                        screenshot={GadgetDetails}
                        active={selectedIndex === 4}
                        containerDataTestId="gadget-details-guide-container"
                        headerTextDataTestId="gadget-details-header-text"
                        screenshotDataTestId="gadget-details-screenshot"
                    />
                    <StepInfo
                        headerText="Verify I/O Formats"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="io-formats-info-text">Check if the I/O formats are mapped from manifest.json after uploading the root ZIP</Typography>}
                        screenshot={IOFormats}
                        active={selectedIndex === 5}
                        containerDataTestId="io-formats-guide-container"
                        headerTextDataTestId="io-formats-header-text"
                        screenshotDataTestId="io-formats-screenshot"
                    />
                    <StepInfo
                        headerText="Verify Icon and Snapshots"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="icon-snapshot-info-text">Check if the Icon and Snapshots are visible after uploading the root ZIP</Typography>}
                        screenshot={IconSnapshots}
                        active={selectedIndex === 6}
                        containerDataTestId="icon-snapshot-guide-container"
                        headerTextDataTestId="icon-snapshot-header-text"
                        screenshotDataTestId="icon-snapshot-screenshot"
                    />
                    <StepInfo
                        headerText="Submit to Admin"
                        infoText={<Typography variant="body1" className={styles.infoText} data-testid="submit-gadget-info-text">After uploading the root ZIP submit agent for review to the admin</Typography>}
                        screenshot={SubmitForReview}
                        active={selectedIndex === 7}
                        containerDataTestId="submit-gadget-guide-container"
                        headerTextDataTestId="submit-gadget-header-text"
                        screenshotDataTestId="submit-gadget-screenshot"
                    />
                </Grid>
            </Grid>
        </div>
    )
}